module.exports = __webpack_public_path__ + "../resources/images/Outlook-d54d452036d387b827f3dcb25ca89339.svg";